import React, { useState } from "react";
import useSound from "use-sound";
import DBLPOP from "../../../assets/music/DBLPOP.mp3";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import s from "./style.module.css";

const QuizType3 = ({ item, index, answer, speakerImg, handleGetAnswer }) => {
  const [play] = useSound(DBLPOP);
  const columnsFromBackend = {
    id1: {
      name: "ตัวเลือก",
      items: item.choices,
    },
    id2: {
      name: item.columnText1,
      items: [],
    },
    id3: {
      name: item.columnText2,
      items: [],
    },
  };
  const [columns, setColumns] = useState(columnsFromBackend);

  const onDragEnd2 = (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          maxHeight: "100%",
          zIndex: 2,
        }}
      >
        {/* {`${index + 1})`} */}
        <DragDropContext
          onDragEnd={(result) => onDragEnd2(result, columns, setColumns)}
        >
          {Object.entries(columns).map(([columnId, column], index) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                key={columnId}
              >
                <h2 style={{ fontSize: "1.5vmax" }}>{column.name}</h2>
                <div style={{ margin: "5px" }}>
                  <Droppable droppableId={columnId} key={columnId}>
                    {(provided, snapshot) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            background: snapshot.isDraggingOver
                              ? "lightblue"
                              : "lightgrey",
                            padding: 4,
                            width: "21.5vmax",
                            height: "20vmax",
                            overflowY: "scroll",
                          }}
                        >
                          {column.items.map((item, index) => {
                            return (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        userSelect: "none",
                                        margin: "0 0 8px 0",
                                        height: "12vmax",
                                        backgroundColor: snapshot.isDragging
                                          ? "#263B4A"
                                          : "#456C86",
                                        ...provided.draggableProps.style,
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                          padding: 15,
                                          height: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* <img
                                          className={s.ChoiceType2speaker}
                                          style={{
                                            position: "absolute",
                                            right: 0,
                                            top: 0,
                                            width: "20%",
                                            height: "20%",
                                          }}
                                          src={speakerImg}
                                          alt=""
                                        /> */}
                                        {!!item.img ? (
                                          <div
                                            style={{
                                              // flex: 1,
                                              display: "flex",
                                              justifyContent: "center",
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            <img
                                              style={{
                                                width: "35%",
                                                height: "100%",
                                              }}
                                              src={item.img}
                                              alt=""
                                            />
                                          </div>
                                        ) : null}
                                        <span
                                          style={{
                                            // flex: 1,
                                            marginLeft: "10px",
                                            fontSize: "1.5vmax",
                                            color: "white",
                                            wordWrap: "break-word",
                                          }}
                                        >
                                          {item.choice_label}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      );
                    }}
                  </Droppable>
                </div>
              </div>
            );
          })}
        </DragDropContext>
      </div>
      {columns.id1.items.length === 0 && (
        <div
          className={s.ChoiceType3}
          onClick={() => {
            handleGetAnswer(item.question_id, columns.id2.items, item.quizType);
            play();
          }}
        >
          submit
        </div>
      )}
    </div>
  );
};

export default QuizType3;
